import EmptyContent from '@/components/Empty/EmptyContent.tsx'
import { memo, useEffect } from 'react'

const EmptyPage = memo(props => {
  useEffect(() => {}, [])
  return <EmptyContent {...props} />
})

export default EmptyPage
